import React from "react";
import { Link } from "react-router-dom";
import {
  Grid,
  Select,
  TextField,
  Container,
  MenuItem,
  InputLabel,
  Button,
  Paper,
  CssBaseline,
  FormControl,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ScrollToTopBtn from "../common/ScrollToTop";
import { connect } from "react-redux";
import * as ClearingUtils from "./ClearingUtils";

class ClearingListUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      clearings: [],
      years: [],
      year: "",
      page: 0,
      rowsPerPage: 50,
      sortDirection: "desc",
      membership: props.type,
    };
  }

  async componentDidMount() {
    try {
      this.setState({ years: ClearingUtils.getYears() });
      await this.fetchClearings();
    } catch (error) {
      console.log("Error in componentDidMount", error);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.type !== prevProps.type) {
      this.setState({ membership: this.props.type });
      this.fetchClearings();
    }
  }

  fetchClearings = async () => {
    try {
      const clearings = await ClearingUtils.getClearings(this.state.membership, this.state.year);
      if (clearings && clearings.length > 0) {
        clearings.sort(this.compareBy("toDate", "desc"));
        this.setState({ clearings: clearings, sortDirection: "desc" });
      } else {
        this.setState({ clearings: [] });
      }
    } catch (error) {
      console.error("Error fetching clearings:", error);
      this.setState({ clearings: [] });
    }
  };

  onChange = async (e) => {
    await this.setState({ [e.target.name]: e.target.value });
    await this.fetchClearings();
  };

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value, page: 0 });
  };

  compareBy = (key, direction) => {
    return function (a, b) {
      if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
      if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
      return 0;
    };
  };

  sortBy = (key) => {
    const { sortDirection, clearings } = this.state;
    const newDirection = sortDirection === "asc" ? "desc" : "asc";
    const sortedArray = [...clearings].sort(this.compareBy(key, newDirection));

    this.setState({
      clearings: sortedArray,
      sortDirection: newDirection,
    });
  };

  render() {
    return (
      <React.Fragment>
        <Container maxWidth="lg" sx={{ ml: 0 }}>
          <main style={{ width: "80%", paddingTop: 80, margin: "auto" }}>
            <Paper sx={{ width: "100%", p: 3 }}>
              <CssBaseline />
              <Grid container alignItems="center" justifyContent="center" spacing={1} sx={{ gap: 2 }}>
                <Typography variant="h6" sx={{ ml: 1, fontSize: "1rem", fontWeight: "bold" }}>
                  Avregninger {this.state.membership}:
                </Typography>
                <Grid item lg={3} sx={{ minWidth: 80, maxWidth: 100 }}>
                  <FormControl fullWidth>
                    <TextField
                      name="membership"
                      label="Organisasjon"
                      value={this.state.membership || ""}
                      variant="standard"
                      InputProps={{ readOnly: true }}
                    />
                  </FormControl>
                </Grid>
                <Grid item lg={2} sx={{ minWidth: 120 }}>
                  <FormControl fullWidth>
                    <InputLabel>År</InputLabel>
                    <Select
                      name="year"
                      value={this.state.year || ""}
                      onChange={this.onChange}
                      variant="standard"
                    >
                      <MenuItem value="">Alle</MenuItem>
                      {this.state.years &&
                        this.state.years.map((year, index) => (
                          <MenuItem key={index} value={year}>
                            {year}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              <Paper sx={{ width: "100%", mt: 3 }}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ backgroundColor: "#f5f5f5 !important", fontWeight: "bold" }}></TableCell>
                      <TableCell
                        sx={{
                          cursor: "pointer",
                          fontWeight: "bold",
                          backgroundColor: "#f5f5f5 !important",
                        }}
                        onClick={() => this.sortBy("toDate")}
                      >
                        År
                      </TableCell>
                      <TableCell
                        sx={{
                          cursor: "pointer",
                          fontWeight: "bold",
                          backgroundColor: "#f5f5f5 !important",
                        }}>Måned
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.clearings.length > 0 ? (
                      this.state.clearings
                        .slice(
                          this.state.page * this.state.rowsPerPage,
                          this.state.page * this.state.rowsPerPage + this.state.rowsPerPage
                        )
                        .map((clearing, index) => (
                          <TableRow hover key={index}>
                            <TableCell align="center">
                              <Link
                                to={`/clearingdetails${this.state.membership}/${clearing.clearingId}`}
                                style={{ textDecoration: "none", color: "#673ab7" }}
                              >
                                <Button variant="outlined" size="medium" color="primary" sx={{ ml: 2 }}>
                                  <ArrowForwardIosIcon sx={{ mr: 1 }} /> Vis Mer
                                </Button>
                              </Link>
                            </TableCell>
                            <TableCell>{new Date(clearing.toDate).getFullYear()}</TableCell>
                            <TableCell>{new Date(clearing.toDate).getMonth() + 1}</TableCell>
                          </TableRow>
                        ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={3} align="center">
                          <Typography>Ingen treff</Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>

                {/* Pagination */}
                <TablePagination
                  rowsPerPageOptions={[5, 10, 50]}
                  component="div"
                  count={this.state.clearings.length}
                  rowsPerPage={this.state.rowsPerPage}
                  page={this.state.page}
                  onPageChange={this.handleChangePage}
                  onRowsPerPageChange={this.handleChangeRowsPerPage}
                />
              </Paper>
            </Paper>
          </main>
        </Container>
        <ScrollToTopBtn />
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const signedinuser = state.signedinuserobject
    ? state.signedinuserobject.signedInUser
    : sessionStorage.getItem("token")
      ? JSON.parse(sessionStorage.getItem("token"))
      : [];

  return { signedinuser };
}

export default connect(mapStateToProps)(ClearingListUser);
